import { CIcon } from '~/icons/types'

export const ciChildrenGoods: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M22 3.238h-1.56a.934.934 0 0 0-.66.274l-.47.47A9.625 9.625 0 0 0 8 2.82a1.368 1.368 0 0 0-.406 2l4.613 6.262-.853.853H5.478a1.37 1.37 0 0 0-1.37 1.366v4.3c-.051 0-.1-.015-.152-.015a2.457 2.457 0 1 0 2.457 2.457 2.422 2.422 0 0 0-.079-.587h4.748a2.237 2.237 0 0 0 1.849-.98l1.149-1.69 1.812 1.815a2.432 2.432 0 0 0-.065 2.809 2.456 2.456 0 1 0 2.042-3.822 2.42 2.42 0 0 0-1.232.344l-1.985-1.985L19.4 8.962a1.37 1.37 0 0 0-.165-1.737l-.889-.89L19.6 5.083a.44.44 0 0 0 .083-.055.46.46 0 0 0 .055-.083l.705-.707H22a.5.5 0 0 0 0-1Zm-4.131 15.348a1.458 1.458 0 1 1 .002 2.916 1.458 1.458 0 0 1-.002-2.916ZM3.956 21.5a1.457 1.457 0 1 1 0-2.915 1.457 1.457 0 0 1 0 2.915ZM5.3 17.99c-.061-.04-.128-.07-.193-.1V13.3a.37.37 0 0 1 .37-.37h4.88L5.3 17.992Zm6.8-.077a1.235 1.235 0 0 1-1.023.542H6.249L11 13.7l2.365 2.365-1.265 1.848Zm6.425-9.982a.37.37 0 0 1 .045.468l-4.641 6.826-2.229-2.232.182-.183a.487.487 0 0 0 .061-.06l1.21-1.213h.012a.466.466 0 0 0 .079-.087l4.4-4.4.881.88Zm-5.6 2.434L8.4 4.222a.37.37 0 0 1 .11-.538 8.626 8.626 0 0 1 10.094 1l-5.679 5.682Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'children-goods',
  type: 'thin'
}
